<template>
  <hr
    :class="[
      'separator',
      { 'separator--line': hasLine },
      { [`separator--${size}`]: !!size },
    ]"
  />
</template>

<script>
export default {
  name: 'Separator',
  props: {
    size: {
      validator(value) {
        return ['small', 'medium', 'large'].includes(value);
      },
    },
    hasLine: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.separator {
  display: inline-block;
  width: 100%;
  border: none;
  border-top: rem(1px) solid transparent;
  margin: 0;

  [class$='__content'] & {
    margin-left: -1rem;
    margin-right: -1rem;

    @include min-width(sm) {
      margin-left: -2rem;
      margin-right: -2rem;
    }
  }
}

.separator--small {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.separator--medium {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.separator--large {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.separator--line {
  border-color: $color-grey-border;
}
</style>
